export const getFeedTypeColor = (type) => {
  switch (type?.toUpperCase()) {
    case 'CELEBRATION':
      return 'text-fuchsia-700 bg-fuchsia-50 border border-fuchsia-200';
    case 'APPRECIATION':
      return 'text-amber-700 bg-amber-50 border border-amber-200';
    case 'IMPORTANT':
      return 'text-red-700 bg-red-50 border border-red-200';
    case 'ANNOUNCEMENT':
    default:
      return 'text-blue-700 bg-blue-50 border border-blue-200';
  }
};
